export const customerTypeParam = 'customerType';
